import { render, staticRenderFns } from "./MakeJobPost.vue?vue&type=template&id=24c86e83&scoped=true&"
import script from "./MakeJobPost.vue?vue&type=script&lang=js&"
export * from "./MakeJobPost.vue?vue&type=script&lang=js&"
import style0 from "./MakeJobPost.vue?vue&type=style&index=0&id=24c86e83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c86e83",
  null
  
)

export default component.exports